import BaseService from "@/services/Base-service.js";

class ReportService {
  get controllerName() { return '/Report/'; }

  getComprehensiveTicketReportForCurrentCompany(filtersVM) {
    return BaseService.get(this.controllerName + 'GetComprehensiveTicketReportForCurrentCompany', filtersVM);
  }

  getComprehensiveCompanyUserReportForCurrentCompany(filtersVM) {
    return BaseService.get(this.controllerName + 'GetComprehensiveCompanyUserReportForCurrentCompany', filtersVM);
  }

  getComprehensiveCustomerReportForCurrentCompany(filtersVM) {
    return BaseService.get(this.controllerName + 'GetComprehensiveCustomerReportForCurrentCompany', filtersVM);
  }
}

export default new ReportService();